import { NetworkRequestState } from '../../../networking/types';
import { GdprWidgetData, GdprWidgetStep } from './types';

export const defaultGdprWidgetState: GdprWidgetData = {
  step: GdprWidgetStep.Initial,
  isDeactivated: false,
  isPersonaldataRequestInitiated: false,
  isRemoveRequestInitiated: false,
  isRemoveRequestInProgress: false,
  isGdprLinkSent: false,
  networkRequests: {
    personalDataRequest: {
      status: NetworkRequestState.IDLE,
      errors: {},
    },
    initiateRemoveDataRequest: {
      status: NetworkRequestState.IDLE,
      errors: {},
    },
    confirmRemoveDataRequest: {
      status: NetworkRequestState.IDLE,
      errors: {},
    },
    resendRemoveConfirmationRequest: {
      status: NetworkRequestState.IDLE,
      errors: {},
    },
    resendDownloadLinkRequest: {
      status: NetworkRequestState.IDLE,
      errors: {},
    },
  },
};
